<template>
  <div id="Contact">
    <SectionContact title="Ready to transform your ESG reporting?" />
  </div>
</template>

<script setup lang="ts">
import SectionContact from '@/views/components/sections/SectionContact.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(
  getSeoConfig('contact'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'Contact', url: 'https://sustainalyse.com/contact' },
  ]),
)
</script>
